import { Controller } from "@hotwired/stimulus"

// Mounted alongside the shared `validation` controller on the same form, which owns the
// submit-button gating through its "email" rule - this form has exactly one field.
//
// The inline "invalid email" message is NOT wired through `validation`'s message target: it arms
// only after the field has been typed into (a hand-rolled "dirty" class set by "input", never by
// blur), and any refocus clears it regardless of validity. Wiring blur->touch here would flag a
// field the user merely tabbed past, so the handler comes straight from window.ltFormValidators.
export default class extends Controller {
  connect() {
    window.ltFormValidators.setInvalidEmailHandler($(this.element));
  }
}
